import React from 'react'
import classnames from 'classnames'

import { Item, Taste } from '../../../core/items'
import { getTasteDisplayName } from '../../../core/i18n'
import { SupportedLanguageCode, LANGUAGE_CODES } from '../../../core/i18n'
import { strings } from './each-item-content'
import styles from '../../styles/modules/table.module.scss'
import formStyles from '../../styles/modules/each-item/each-item-forms.module.scss'
import Button from '../button'

interface Props {
  item: Item
  newTaste: Taste
  activeLanguage: SupportedLanguageCode
  onChangeTastes: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChangeNewTaste: (event: React.ChangeEvent<HTMLInputElement>) => void
  onAddNewTaste: () => void
  onDeleteTaste: (event: React.MouseEvent<HTMLElement>) => void
}

const TastesForm: React.FC<Props> = props => {
  const { activeLanguage } = props

  // 定数定義
  const isEnglishMode = activeLanguage === LANGUAGE_CODES.ENGLISH
  const tasteNameFieldName = isEnglishMode
    ? `itemTasteTranslations.${activeLanguage}.name`
    : 'name'
  const valueFieldName = 'value'

  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.stocker]: true,
      })}
    >
      <table className={`${styles.container} ${styles.tastesTable}`}>
        <tbody>
          {props.item.tastes.map((taste, i) => (
            <tr className={styles.rowStatic} key={i}>
              <td className={styles.cell}>
                <input
                  className={formStyles.input}
                  value={getTasteDisplayName(taste, activeLanguage)}
                  placeholder="味の特徴名"
                  name={tasteNameFieldName}
                  data-num={i}
                  onChange={props.onChangeTastes}
                />
              </td>
              <td className={styles.cell}>
                <input
                  className={formStyles.input}
                  value={taste.value ?? ''}
                  placeholder={'値'}
                  name={valueFieldName}
                  data-num={i}
                  onChange={props.onChangeTastes}
                  disabled={isEnglishMode}
                  style={isEnglishMode ? { opacity: 0.5 } : {}}
                />
              </td>
              <td className={styles.cell}>
                <Button
                  className={formStyles.deleteButton}
                  title={strings.delete}
                  data-num={i}
                  onClick={props.onDeleteTaste}
                />
              </td>
            </tr>
          ))}
          <tr className={styles.rowStatic}>
            <td className={styles.cell}>
              <input
                className={formStyles.input}
                value={getTasteDisplayName(props.newTaste, activeLanguage)}
                placeholder="味の特徴名"
                name={tasteNameFieldName}
                onChange={props.onChangeNewTaste}
              />
            </td>
            <td className={styles.cell}>
              <input
                className={formStyles.input}
                value={props.newTaste.value ?? ''}
                placeholder={'値'}
                name={valueFieldName}
                onChange={props.onChangeNewTaste}
                disabled={isEnglishMode}
                style={isEnglishMode ? { opacity: 0.5 } : {}}
              />
            </td>
            <td className={styles.cell}>
              <Button
                className={formStyles.addButton}
                title={strings.add}
                disabled={
                  !getTasteDisplayName(props.newTaste, activeLanguage) ||
                  !props.newTaste.value
                }
                onClick={props.onAddNewTaste}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default TastesForm
